export type Role = RoleGeneralManager | RoleGeneralViewer | RoleNone;
type RoleGeneralManager = 'general_manager';
type RoleGeneralViewer = 'general_viewer';
type RoleNone = 'none';

const RoleKeyValues = {
  general_manager: '全体管理者',
  general_viewer: '全体閲覧者',
  none: 'なし',
};
export const getRoleLabel = (role: Role) => {
  return RoleKeyValues[role];
};
export const getOptions = () => {
  return Object.keys(RoleKeyValues).map((role: string) => {
    return {
      id: role,
      name: getRoleLabel(role as Role),
    };
  });
};
